import React, { useState } from 'react';

import type { BlockTableOfContents } from 'types/block-table-of-contents';

import { Link } from '@leafwell/components';
import Image from 'next/image';

import { useWordPressContext } from 'contexts/wordpress-provider';
import { useScrollNav } from 'hooks/useScrollNav';

const TableOfContentsBlock: React.FC<BlockTableOfContents> = ({
  tableOfContents,
}) => {
  const { translations } = useWordPressContext();
  const [showTable, toggleTable] = useState<boolean>(false);
  const [showLabel, toggleLabel] = useState<boolean>(false);
  const [observable] = useState(null);
  const [activeItem, setActiveItem] = useScrollNav(observable);

  if (tableOfContents.length > 0) {
    return (
      <div
        className={[
          showTable ? 'translate-x-0' : '-translate-x-full',
          'fixed top-0 z-50 h-screen duration-500',
        ].join(' ')}
      >
        <button
          className="table-contents-btn absolute top-1/2 left-full w-5 lg:w-8 h-6 lg:h-12 border-r border-solid border-r-gray-400 bg-white lg:hover:bg-gray-100 duration-300 contents-btn-shake"
          onClick={() => {
            toggleTable(!showTable);
            toggleLabel(false);
          }}
          onMouseEnter={() => {
            toggleLabel(true);
          }}
          onMouseLeave={() => {
            toggleLabel(false);
          }}
        >
          <Image
            className={[
              showTable ? 'rotate-90' : '-rotate-90',
              'relative -top-1 lg:top-0 -left-2 lg:left-0 z-10 max-w-none	lg:max-w-full w-8 lg:w-auto duration-500',
            ].join(' ')}
            src="/chevron.svg"
            width={30}
            height={30}
            alt=""
          />
          <p
            className={[
              !showTable && showLabel ? 'left-full' : '-translate-x-[110%]',
              'absolute -top-[5px] lg:top-2.5 -z-10 whitespace-nowrap duration-300',
              'py-1 lg:py-0 px-2',
            ].join(' ')}
          >
            {translations['Table of content']}
          </p>
        </button>
        <div className="w-80 h-full pt-10 pr-4 pl-12 bg-white border-r border-solid border-r-gray-400">
          <p className="mb-6 text-lg font-medium">
            {translations['Table of content']}
          </p>
          <ol className="grid gap-y-5 list-outside pl-list list-decimal table-contents-list">
            {tableOfContents.map(({ id, label }) => (
              <li key={id} className="mb-3">
                <Link
                  {...{
                    className: '',
                    href: `#${id}`,
                    role: 'link',
                    onClick: () => {
                      toggleTable(false);
                      setActiveItem({ id });
                    },
                    variant:
                      activeItem === id
                        ? 'underlineHighlight'
                        : 'underlineHover',
                  }}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </div>
    );
  }
};

export default TableOfContentsBlock;
